module.exports = require("@material-ui/icons/Close");